var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 38,
    viewBox: "0 0 52 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 7.33366L9.35108 7.33366C11.0467 7.33366 12.6729 6.49437 13.872 5.00043C15.5843 2.86685 18.1172 2.12184 20.4146 3.076L23.666 4.42638M2.66602 28.2562H6.4476C9.15303 28.2562 10.5058 28.2562 11.785 28.6166C11.8471 28.6342 11.9091 28.6523 11.9709 28.6711C13.242 29.0571 14.3676 29.7825 16.6187 31.2333C21.0244 34.0728 23.2272 35.4925 25.6276 35.3195C25.7408 35.3114 25.8537 35.3006 25.9663 35.2871C28.3552 35.0016 30.2272 33.1918 33.9713 29.5722L37.666 26.0003M49.3327 7.87929L43.4601 7.87929C40.9733 7.87929 39.2174 6.52792 37.4335 4.72634C36.278 3.55941 34.8031 2.87168 33.2531 2.77697C31.5201 2.67108 29.5117 2.52199 27.8286 2.98435C25.9553 3.49897 24.7183 4.90846 23.4098 6.38155L20.0332 10.1829C18.6547 11.7348 18.6547 14.2509 20.0332 15.8028C21.223 17.1423 23.0872 17.3501 24.4872 16.2994C25.4947 15.5432 26.6393 14.3221 27.8265 13.9376C29.1627 13.5048 29.9914 14.4771 30.7486 15.5001L36.1624 22.8138C38.1716 25.5282 39.1762 26.8853 40.5495 27.6095C41.9229 28.3337 43.4922 28.3337 46.6306 28.3337H49.3327",
    stroke: "#2786BD",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreement);
export default __webpack_public_path__ + "static/media/agreement.970d6932020e19ec952d11d7338a7105.svg";
export { ForwardRef as ReactComponent };